import { useState, useEffect } from "react";
import { createContext, useContext } from "react";
import { Auth, Hub } from "aws-amplify";
import { useTranslation } from "react-i18next";

interface AuthContextType {
  user: any;
  isLoading: boolean;
  setUser: Function;
}

const UserContext = createContext({} as AuthContextType);

export default function AuthContext({ children }: any) {
  const { i18n } = useTranslation();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkUser();
  }, []);

  useEffect(() => {
    Hub.listen("auth", () => {
      checkUser();
    });
  }, []);

  async function checkUser() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        setUser(user);
      }
      if (user.attributes["custom:preferred_language"]) {
        i18n.changeLanguage(user.attributes["custom:preferred_language"]);
      }
    } catch (error) {
      setUser(null);
    }
    setIsLoading(false);
  }

  return (
    <UserContext.Provider
      value={{
        user,
        isLoading,
        setUser
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => useContext(UserContext);
